export default __webpack_public_path__ + "static/media/help.38cc1014.svg";